/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Outlook_Revoke_Confirm_ButtonInputs */



/**
* | output |
* | --- |
* | "Disconnect" |
*
* @param {Connections_Outlook_Revoke_Confirm_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_outlook_revoke_confirm_button = /** @type {((inputs?: Connections_Outlook_Revoke_Confirm_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Outlook_Revoke_Confirm_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Trennen")
	return /** @type {LocalizedString} */ ("Disconnect")
});